<template>
    <a :href="url" class="button">
        <slot></slot>
    </a>
</template>

<script>
export default {
    name: "ButtonLinkComponent",
    props: ['url'],
}
</script>

<style scoped lang="scss">
.button {
    background: linear-gradient(135deg, #9b5cf7, #7b40ee);
    text-decoration: none;
    font-weight: 600;
    color: white;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 20px;
    margin-top: 8px;
    border: 3px solid rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    cursor: pointer;
    position: relative;
    transition: all 0.3s ease;
    box-shadow:
        0 4px 6px rgba(155, 92, 247, 0.2),
        0 0 8px rgba(155, 92, 247, 0.4),
        inset 0 1px 2px rgba(255, 255, 255, 0.1);

    &:hover {
        box-shadow:
            0 6px 16px rgba(155, 92, 247, 0.3),
            0 0 12px rgba(155, 92, 247, 0.55),
            inset 0 1px 3px rgba(255, 255, 255, 0.15);
        transform: translateY(-2px);
    }

    &:active {
        transform: scale(0.98);
        box-shadow:
            0 2px 8px rgba(155, 92, 247, 0.3),
            0 0 12px rgba(155, 92, 247, 0.5),
            inset 0 2px 4px rgba(255, 255, 255, 0.1);
    }
}
</style>